
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Mail')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M227.17,252.24c-6.54,0-12,1.08-16.37,3.46L390,419.41c7.27,4,12.81,4,20.08,0L589.2,255.7c-4.28-2.32-9.46-3.46-15.75-3.46Zm-37.73,30.08a54.55,54.55,0,0,0-1.39,12.46V505.22a50.07,50.07,0,0,0,2,14.88l126.8-120.79Zm421.28,0-127.58,117L609.94,520.1a52.59,52.59,0,0,0,2-15.4V294.26A53.64,53.64,0,0,0,610.72,282.32ZM341.93,422.81,213.27,545.34a37.47,37.47,0,0,0,14.21,2.42H573.14a36,36,0,0,0,13.59-2.42L458.07,422.81c-12.85,11.61-25.93,23.83-38.76,35.13a38.81,38.81,0,0,1-38.62,0C367.77,446.62,354.79,434.52,341.93,422.81Z","transform":"translate(0 0)"}})])])
          )
        }
      }
    